// extracted by mini-css-extract-plugin
export default {"grid":"CampaignFundingTierPreviewGridFullWidth_grid__XKj0Y"};